import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './style.scss';

/**
 *
 */
function StepInfo({
  step, loading,
}) {
  return (
    <div className="whatsapp-step-info-wrapper">
      {loading
        ? (
          <div className="whatsapp-step-info-loading__wrapper">
            {[1, 2]?.map((item) => (
              <div key={item} className="whatsapp-step-info-loading-line">
                <div className="loadingBlock whatsapp-step-info-loading-dot" />
                <div className="loadingBlock whatsapp-step-info-loading-text" />
              </div>
            ))}
          </div>
        )
        : (
          <div style={{ marginTop: '35px' }} className="whatsapp-step-border">
            {/* <div className="whatsapp-step-info-status-wrapper">
              <div className={`dot ${ step === 1 ? 'dot-blue' : 'dot-green' }`} />
              <div className="whatsapp-step-info-status-heading-active">&nbsp;Account Setting</div>
            </div> */}
            <div className="whatsapp-step-info-status-wrapper">
              <div className={`dot dot-grey ${ step === 1 ? 'dot-blue' : 'dot-green'} `} />
              <div className="whatsapp-step-info-status-heading-active">&nbsp;Configuration</div>
            </div>
            <div className="whatsapp-step-info-status-wrapper">
              <div className={`dot dot-grey ${ step === 2 ? 'dot-blue' : step > 1 && 'dot-green' }`} />
              <div className="whatsapp-step-info-status-heading-active">&nbsp;Review & Save</div>
            </div>
          </div>
        )}
    </div>
  );
}

const mapStateToProps = () => ({

});
const mapDispatchToProps = () => ({
});
StepInfo.propTypes = {
  step: PropTypes.any,
  loading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StepInfo));
